import * as React from "react";
// import { io } from "socket.io-client";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  Grid,
  IconButton,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Tabs,
  Tab,
  Stack,
  Rating,
} from "@mui/material";
import Pusher from "pusher-js";
import { Close as CloseIcon } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Wrapper from "../../../components/Wrapper";
import title from "../../../components/title";
import { useFormik } from "formik";
import { maintenanceRequestValidationSchema } from "./maintenanceRequestValidation";
import { ToastContainer, toast } from "react-toastify";
import { GetAllLandlordMaintenanceRequest } from "../../../redux/reducer/GetAllLandlordMaintenanceRequest";
import { RequestResponseLandlord } from "../../../redux/reducer/RequestResponseLandlord";
import { Drawer } from "@mui/material";
import { Send as SendIcon } from "@mui/icons-material";
import { SendChat } from "../../../redux/reducer/SendChat";
import { GetAllMaintenanceRequestChat } from "../../../redux/reducer/GetMaintenanceRequestChat";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import DescriptionCell from "../../../components/Description";
import moment from "moment";
import ImageZoomModal from "../../../components/ImageZoomModal";
import RecordNotFound from "../../../components/RecordNotFound";
const userID = localStorage.getItem("user_id");
export default function LandlordMaintenanceRequest() {
  const open = useSelector((state) => state.sidebar.open);
  title("Maintenance Request");

  const mylocation = "/landlord-maintenance-request";
  const [openChatSidebar, setOpenChatSidebar] = useState(false);
  const [pusherChannel, setPusherChannel] = useState(null);
  const [pusherClient, setPusherClient] = useState(null);
  const [zoomOpen, setZoomOpen] = useState(false);
  const [zoomImages, setZoomImages] = useState([]);
  const [zoomIndex, setZoomIndex] = useState(0);
  // const getId = window.location.pathname.replace(
  //   "/landlord-maintenance-request/",
  //   ""
  // );
  // const [requests, setRequests] = useState([]);
  const requests = useSelector(
    (state) => state?.landlordMaintenanceRequest?.GetMaintenanceAll
  );
  const dataLoading = useSelector(
    (state) => state?.landlordMaintenanceRequest?.loading
  );
  const data = useSelector(
    (state) => state?.maintenanceRequestChat?.GetMaintenanceChat
  );
  const [tab, setTab] = useState(0); // 0: All, 1: Pending, 2: In Progress, 3: Completed

  const [openModal, setOpenModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  const statusLabels = ["all", "pending", "accepted", "completed", "rejected"];
  const [openChatModal, setOpenChatModal] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);

  // const socket = io(BASE_URL, {
  //   query: { userId: userID },
  // });
  const [chatMessage, setChatMessage] = useState("");
  const [messages, setMessages] = useState({});

  const dispatch = useDispatch();
  // useEffect(() => {
  //   // Receive Messages
  //   socket.on("receiveMessage", (data) => {
  //     setMessages((prev) => [...prev, data]);
  //   });

  //   return () => {
  //     socket.off("receiveMessage");
  //   };
  // }, []);
  const handleSendMessage = async () => {
    if (!chatMessage.trim()) return;

    const msgData = {
      senderId: userID,
      requestId: formik.values.selectedRequest?._id, //maintenance id
      message: chatMessage,
      timestamp: new Date(),
    };
    await dispatch(SendChat({ ...msgData }));
    // await axios.post(`${BASE_URL}/chat/send`, {
    //   ...msgData,
    // });
    // socket.emit("sendMessage", msgData);

    // setMessages((prev) => [...prev, msgData]);
    setChatMessage("");
  };

  useEffect(() => {
    dispatch(GetAllLandlordMaintenanceRequest({ userId: userID }));
  }, [dispatch, tab]);

  useEffect(() => {
    const pusher = new Pusher("b7e67e30cdf802e24783", { cluster: "ap2" });
    setPusherClient(pusher);

    return () => {
      pusher.disconnect();
    };
  }, []);
  // useEffect(() => { fetchRequests(); }, [getId]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  // ✅ Handle Accept or Reject using Formik only
  const handleAction = (req, type) => {
    formik.setValues({
      ...formik.values,
      selectedRequest: req,
      actionType: type,
      reply: "",
      startDate: "",
      endDate: "",
      visitTime: "",
    });
    if (type === "message") {
      setOpenChatModal(true);
      return;
    }
    setOpenModal(true);
  };

  // ---------- Formik ----------
  const formik = useFormik({
    initialValues: {
      selectedRequest: null,
      actionType: "",
      reply: "",
      startDate: "",
      endDate: "",
      visitTime: "",
      media: [],
      previews: [],
    },
    validationSchema: maintenanceRequestValidationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const req = values.selectedRequest;
        const now = moment().format("DD-MM-YYYY hh:mm A");
        // const payload = {
        //   ...req,
        //   status: values.actionType === "accepted" ? "accepted" : "rejected",
        //   reply: values.reply,
        //   actionType: values.actionType,
        //   ...(values.actionType === "accepted" && {
        //     startDate: values.startDate,
        //     endDate: values.endDate,
        //     visitTime: values.visitTime,
        //   }),
        // };

        const payload = {
          ...req,
          status: values.actionType === "accepted" ? "accepted" : "rejected",
          reply: values.reply,
          actionType: values.actionType,

          ...(values.actionType === "accepted"
            ? {
                accepted_date: now,
                startDate: values.startDate,
                endDate: values.endDate,
                visitTime: values.visitTime,
              }
            : {
                rejected_date: now,
              }),
        };

        await dispatch(RequestResponseLandlord(payload)).unwrap();
        // const res = await fetch(`${BASE_URL}/update-maintenance-status`, {
        //   method: "PUT",
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${token}`,
        //   },
        //   body: JSON.stringify(payload),
        // });

        // const data = await res.json();
        // if (!res.ok) throw new Error(data.reply);

        // toast.success(
        //   values.actionType === "accept"
        //     ? "Request accepted successfully!"
        //     : "Request rejected successfully!"
        // );

        resetForm();
        setOpenModal(false);
        dispatch(GetAllLandlordMaintenanceRequest({ userId: userID }));
      } catch (err) {
        toast.error("Failed to update request");
      }
    },
  });
  useEffect(() => {
    if (!formik.values.selectedRequest?._id) return;
    if (!data?.data?.length) return;

    const reqId = formik.values.selectedRequest._id;

    setMessages((prev) => ({
      ...prev,
      [reqId]: data.data[0].chats || [],
    }));
    setChatLoading(false);
  }, [data, formik.values.selectedRequest]);

  // ---------- Filtered requests by tab ----------
  const filteredRequests =
    tab === 0
      ? requests?.data
      : requests?.data?.filter(
          (r) => r.status.toLowerCase() === statusLabels[tab]
        );
  const checkAccept = requests?.data?.some(
    (e) =>
      e.status?.toLowerCase() === "accepted" ||
      e.status?.toLowerCase() === "pending"
  );

  const handleOpenChatSidebar = async (req) => {
    setChatLoading(true);
    dispatch(GetAllMaintenanceRequestChat(req._id));
    // const { data } = await axios.get(
    //   `${BASE_URL}/get-maintenance-request-chat/${req._id}`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.getItem("ots_token")}`,
    //     },
    //   }
    // );

    formik.setValues({
      ...formik.values,
      selectedRequest: req,
      actionType: "message",
    });

    // setMessages((prev) => ({
    //   ...prev,
    //   [req._id]: data.data?.[0].chats || [],
    // }));
    // setMessages((prev) => ({
    //   ...prev,
    //   [req._id]: data.data?.[0].chats || [],
    // }));

    setOpenChatSidebar(true);

    // Subscribe only if not already subscribed
    if (pusherClient && !pusherChannel) {
      const channel = pusherClient.subscribe(`chat-room-${req._id}`);
      channel.bind("message", (msg) => {
        setMessages((prev) => ({
          ...prev,
          [req._id]: [...(prev[req._id] || []), msg],
        }));
      });
      setPusherChannel(channel);
    }
  };

  // Function to close chat
  const handleCloseChatSidebar = () => {
    setOpenChatSidebar(false);
    const requestId = formik.values.selectedRequest?._id;

    if (pusherChannel && pusherClient) {
      pusherClient.unsubscribe(`chat-room-${requestId}`);
      setPusherChannel(null);
    }
  };

  const currentRequestId = formik.values.selectedRequest?._id;
  const currentMessages = messages[currentRequestId] || [];
  // --- Utility function for date groups ---
  const groupMessagesByDate = (messages) => {
    const groups = {};

    messages.forEach((msg) => {
      const date = new Date(msg.timestamp);
      const dateKey = date.toDateString(); // e.g. "Mon Nov 17 2025"

      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(msg);
    });

    return groups;
  };

  // --- Utility for heading (Today, Yesterday, or date) ---
  const formatDateHeading = (dateString) => {
    const msgDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (msgDate.toDateString() === today.toDateString()) {
      return "Today";
    }
    if (msgDate.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    }

    return msgDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      <Wrapper open={open} mylocation={mylocation} />
      <div className={`${open ? "sidebar-open" : "sidebar-closed"} `}>
        <div
          className="mainHeading"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <h1 style={{ marginBottom: "10px" }}>Maintenance Request</h1>
        </div>

        {/* ---------- Tabs ---------- */}
        {dataLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", m: 10 }}>
            <Typography sx={{ fontSize: 40 }}>
              <CircularProgress />
            </Typography>
          </Box>
        ) : requests?.length === 0 ? (
          <RecordNotFound />
        ) : (
          <>
            <Tabs value={tab} onChange={handleTabChange} sx={{ mt: 2 }}>
              <Tab label="All" />
              <Tab label="Pending" />
              <Tab label="Accepted" />
              <Tab label="Completed" />
              <Tab label="Rejected" />
            </Tabs>

            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Flat Number</TableCell>
                    <TableCell>Flat Name</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Urgency</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Media</TableCell>
                    <TableCell>Reply</TableCell>
                    <TableCell>Rating</TableCell>
                    {checkAccept === true ? <TableCell>Action</TableCell> : ""}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRequests?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No requests
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredRequests?.map((req) => (
                      <TableRow key={req._id}>
                        <TableCell>
                          {req?.propertyDetail[0]?.flatNumber}
                        </TableCell>
                        <TableCell>
                          {req?.propertyDetail[0]?.flatName}
                        </TableCell>
                        <TableCell>{req.category}</TableCell>
                        <TableCell>
                          <DescriptionCell description={req.description} />
                        </TableCell>

                        <TableCell>{req.urgency}</TableCell>
                        <TableCell>
                          <Chip
                            label={req.status}
                            color={
                              req.status.toLowerCase() === "pending"
                                ? "warning"
                                : req.status.toLowerCase() === "accepted"
                                ? "success"
                                : req.status.toLowerCase() === "rejected"
                                ? "error"
                                : // : req.status.toLowerCase() === "in-progress"
                                //   ? "info"
                                req.status.toLowerCase() === "completed"
                                ? "success"
                                : "default"
                            }
                          />
                        </TableCell>
                        <TableCell>
                          {req.media && req.media.length > 0 ? (
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-block",
                              }}
                            >
                              {/* Thumbnail (always first image) */}
                              <img
                                src={
                                  req.media[0].fileUrl || req.media[0].fileName
                                }
                                alt="thumbnail"
                                onClick={() => {
                                  setZoomImages(
                                    req.media.map(
                                      (m) => m.fileUrl || m.fileName
                                    )
                                  );
                                  setZoomIndex(0);
                                  setZoomOpen(true);
                                }}
                                style={{
                                  width: 45,
                                  height: 45,
                                  objectFit: "cover",
                                  borderRadius: 6,
                                  cursor: "pointer",
                                }}
                              />

                              {/* Count Badge (only if more than 1 image) */}
                              {req.media.length > 1 && (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    bottom: -8,
                                    right: -8,
                                    background: "var(--owner-primary)",
                                    color: "white",
                                    width: 22,
                                    height: 22,
                                    borderRadius: "50%",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "2px solid white",
                                  }}
                                >
                                  +{req.media.length - 1}
                                </Box>
                              )}
                            </Box>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell>
                          {req?.status === "pending" ? (
                            "-"
                          ) : (
                            <DescriptionCell description={req.reply} />
                          )}
                        </TableCell>
                        <TableCell>
                          {req?.status === "rejected" ||
                          req?.status === "pending" ? (
                            "-"
                          ) : (
                            <Rating
                              value={Number(req?.rating) || 0}
                              readOnly
                              precision={1}
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            {req?.status === "accepted" ? (
                              <>
                                <Button
                                  variant="contained"
                                  color="success"
                                  size="small"
                                  // onClick={() => handleAction(req, "message")}
                                  onClick={() => handleOpenChatSidebar(req)}
                                >
                                  Message
                                </Button>
                              </>
                            ) : req?.status === "rejected" ? (
                              ""
                            ) : req?.status === "completed" ? (
                              ""
                            ) : (
                              <>
                                <Button
                                  variant="contained"
                                  color="success"
                                  size="small"
                                  onClick={() => handleAction(req, "accepted")}
                                >
                                  Accept
                                </Button>
                                <Button
                                  variant="contained"
                                  color="error"
                                  size="small"
                                  onClick={() => handleAction(req, "rejected")}
                                >
                                  Reject
                                </Button>
                              </>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

          </>
        )}
        {/* ---------- Table ---------- */}
        {/* {dataLoading ? (
          <Box display="flex" justifyContent="center" mt={3}>
            <CircularProgress />
          </Box>
        ) : (
          ""
        )} */}

        {/* ---------- Modal Form ---------- */}
        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              p: 3,
              borderRadius: 2,
              width: { xs: "95%", sm: 500, md: 650 },
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <Typography variant="h6" mb={2}>
              {formik.values.actionType === "accepted"
                ? "Accept Maintenance Request"
                : "Reject Maintenance Request"}
            </Typography>

            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                {/* Reply */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    label="Reply"
                    name="reply"
                    value={formik.values.reply}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.reply && Boolean(formik.errors.reply)}
                    helperText={formik.touched.reply && formik.errors.reply}
                  />
                </Grid>
                {formik.values.actionType === "accepted" && (
                  <>
                    {/* Start Date */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Start Date"
                        type="date"
                        name="startDate"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={formik.values.startDate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.startDate &&
                          Boolean(formik.errors.startDate)
                        }
                        helperText={
                          formik.touched.startDate && formik.errors.startDate
                        }
                      />
                    </Grid>

                    {/* End Date */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="End Date"
                        type="date"
                        name="endDate"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={formik.values.endDate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.endDate &&
                          Boolean(formik.errors.endDate)
                        }
                        helperText={
                          formik.touched.endDate && formik.errors.endDate
                        }
                      />
                    </Grid>

                    {/* Visit Time */}
                    <Grid item xs={12}>
                      <TextField
                        label="Visit Time"
                        type="time"
                        name="visitTime"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={formik.values.visitTime}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.visitTime &&
                          Boolean(formik.errors.visitTime)
                        }
                        helperText={
                          formik.touched.visitTime && formik.errors.visitTime
                        }
                      />
                    </Grid>
                  </>
                )}
                {/* Submit button */}
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? (
                      <CircularProgress size={24} />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Modal>

        {/* ---------- Chat Modal ---------- */}
        <Modal open={openChatModal} onClose={() => setOpenChatModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              p: 2,
              width: { xs: "90%", sm: 400 },
              borderRadius: 2,
              maxHeight: "80vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="h6" mb={1}>
              Chat with Tenant
            </Typography>

            {/* Messages Box */}
            <Box
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: 1,
                p: 1,
                mb: 1,
              }}
            >
              {/* {messages.length === 0 ? (
                <Typography color="text.secondary" textAlign="center">
                  No messages yet
                </Typography>
              ) : (
                messages.map((msg, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      justifyContent:
                        msg.senderId === userID ? "flex-end" : "flex-start",
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        p: 1,
                        bgcolor:
                          msg.senderId === userID ? "primary.main" : "grey.300",
                        color: msg.senderId === userID ? "white" : "black",
                        borderRadius: 1.5,
                        maxWidth: "70%",
                      }}
                    >
                      {msg.message}
                    </Box>
                  </Box>
                ))
              )} */}
            </Box>

            {/* Input + Send */}
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Type message..."
                value={chatMessage}
                onChange={(e) => setChatMessage(e.target.value)}
              />
              <Button variant="contained" onClick={handleSendMessage}>
                Send
              </Button>
            </Box>
          </Box>
        </Modal>
        <Drawer
          anchor="right"
          open={openChatSidebar}
          onClose={handleCloseChatSidebar}
        >
          <Box
            sx={{
              width: { xs: 300, sm: 400 },
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            {/* Header with Close */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderBottom: "1px solid #ddd",
              }}
            >
              <Typography variant="h6">Chat with Tenant</Typography>
              <IconButton onClick={handleCloseChatSidebar}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Messages */}
            <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
              {chatLoading ? (
                <Box sx={{ textAlign: "center", mt: 2 }}>
                  <CircularProgress size={25} />
                  <Typography variant="caption" display="block" mt={1}>
                    Loading messages...
                  </Typography>
                </Box>
              ) : !currentMessages || currentMessages.length === 0 ? (
                <Box
                  sx={{
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    p: 3,
                    height: "80vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <IconButton
                      aria-label="no-messages"
                      sx={{
                        bgcolor: "action.hover",
                        width: 64,
                        height: 64,
                        "&:hover": { bgcolor: "action.selected" },
                        boxShadow: 0.5,
                      }}
                    >
                      <ChatBubbleOutlineIcon fontSize="large" />
                    </IconButton>

                    <Box>
                      <Typography
                        color="text.secondary"
                        variant="body1"
                        sx={{ textAlign: "left" }}
                      >
                        No messages yet
                      </Typography>
                      <Typography
                        color="text.secondary"
                        variant="caption"
                        sx={{ display: "block", mt: 0.5 }}
                      >
                        Start a conversation or send your first message.
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              ) : (
                /* 🟢 Step 3: Show grouped messages */
                Object.entries(groupMessagesByDate(currentMessages)).map(
                  ([dateKey, msgs]) => (
                    <React.Fragment key={dateKey}>
                      {/* Date Heading */}
                      <Box sx={{ textAlign: "center", my: 2 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            bgcolor: "#e0e0e0",
                            display: "inline-block",
                            px: 2,
                            py: 0.5,
                            borderRadius: 2,
                            fontWeight: 600,
                          }}
                        >
                          {formatDateHeading(dateKey)}
                        </Typography>
                      </Box>

                      {/* Messages */}
                      {msgs.map((msg, i) => {
                        const timeString = new Date(
                          msg.timestamp
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        });

                        return (
                          <Box
                            key={i}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems:
                                msg.senderId === userID
                                  ? "flex-end"
                                  : "flex-start",
                              mb: 1.5,
                            }}
                          >
                            <Box
                              sx={{
                                p: 1.2,
                                bgcolor:
                                  msg.senderId === userID
                                    ? "#DCF8C6" // Sender bubble (your message - green)
                                    : "#FFFFFF", // Receiver bubble (white like WhatsApp)
                                color: "black",
                                borderRadius: 2,
                                maxWidth: "70%",
                                boxShadow: 1,
                                alignSelf:
                                  msg.senderId === userID
                                    ? "flex-end"
                                    : "flex-start",
                                borderTopLeftRadius: 16,
                                borderTopRightRadius: 16,
                                borderBottomLeftRadius:
                                  msg.senderId === userID ? 16 : 4,
                                borderBottomRightRadius:
                                  msg.senderId === userID ? 4 : 16,
                              }}
                            >
                              {msg.message}
                            </Box>

                            <Typography
                              variant="caption"
                              sx={{ mt: 0.3, opacity: 0.7 }}
                            >
                              {timeString}
                            </Typography>
                          </Box>
                        );
                      })}
                    </React.Fragment>
                  )
                )
              )}
            </Box>

            {/* Input + Send */}
            <Box sx={{ display: "flex", p: 2, gap: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Type message..."
                value={chatMessage}
                onChange={(e) => setChatMessage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSendMessage();
                }}
              />
              <IconButton color="primary" onClick={handleSendMessage}>
                <SendIcon />
              </IconButton>
            </Box>
          </Box>
        </Drawer>
        <ImageZoomModal
          open={zoomOpen}
          onClose={() => setZoomOpen(false)}
          images={zoomImages}
          index={zoomIndex}
          setIndex={setZoomIndex}
        />
        <ToastContainer />
      </div>
    </>
  );
}
